import React from 'react';
import './Sidebar.css';
import { GLOBAL_CHAT_UI_ENABLED, TOURNAMENTS_NAV_UI_ENABLED } from '../utils/constants';

interface SidebarProps {
  onPlayClick: () => void;
  onHowToPlayClick: () => void;
  onAboutClick: () => void;
  onPlayersClick?: () => void;
  onStatsClick?: () => void;
  onLeaderboardClick?: () => void;
  onRulesClick?: () => void;
  onSettingsClick?: () => void;
  onPuzzlesClick?: () => void;
  onSpectatorClick?: () => void;
  onChatClick?: () => void;
  onTournamentsClick?: () => void;
  onGreedyClick?: () => void;
  onShopClick?: () => void;
  authState: {
    isAuthenticated: boolean;
    user: {
      username: string;
      email: string;
      isAdmin?: boolean;
    } | null;
    isGuest: boolean;
  };
  onLogout: () => void;
  onSignInClick: () => void;
  onSignUpClick: () => void;
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  closeMobileMenu: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  onPlayClick, 
  onHowToPlayClick, 
  onAboutClick,
  onPlayersClick,
  onStatsClick,
  onLeaderboardClick,
  onRulesClick,
  onSettingsClick,
  onPuzzlesClick,
  onSpectatorClick,
  onChatClick,
  onTournamentsClick,
  onGreedyClick,
  onShopClick,
  authState, 
  onLogout, 
  onSignInClick, 
  onSignUpClick,
  isMobileMenuOpen,
  toggleMobileMenu,
  closeMobileMenu
}) => {
 const handleNavClick = (section: string) => {
  if (section === 'play') {
    onPlayClick();
  } else if (section === 'Tutorial') {
    onHowToPlayClick();
  } else if (section === 'players') {
    onPlayersClick?.();
  } else if (section === 'stats') {
    onStatsClick?.();
  } else if (section === 'leaderboard') {
    onLeaderboardClick?.();
  } else if (section === 'rules') {
    onRulesClick?.();
  } else if (section === 'settings') {
    onSettingsClick?.();
  } else if (section === 'puzzles') {
    onPuzzlesClick?.();
  } else if (section === 'spectator') {
    onSpectatorClick?.();
  } else if (section === 'chat') {
    onChatClick?.();
  } else if (section === 'tournaments') {
    onTournamentsClick?.();
  } else if (section === 'greedy') {
    onGreedyClick?.();
  } else if (section === 'shop') {
    onShopClick?.();
  } else if (section === 'videos') {
    window.open('https://www.youtube.com/channel/UCXqT-GBhTzM_Gw37aG-j8JQ', '_blank');
  } else if (section === 'discord') {
    window.open('https://discord.gg/ZZYdFFSNmZ', '_blank');
  } else if (section === 'about') {
    onAboutClick();
  }

  closeMobileMenu();
};



  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
    }
  };

  return (
    <>
      {/* Mobile Menu Toggle Button */}
      <button 
        className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Mobile Overlay */}
      <div 
        className={`sidebar-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />

      <div className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <img 
          src="/migoyugo-logo.png" 
          alt="MIGOYUGO" 
          className="sidebar-logo-img"
        />
      </div>

      {/* Navigation Items */}
      {/* Navigation Items */}
<nav className="sidebar-nav">
  <div className="sidebar-shop-box">
    <button onClick={() => handleNavClick('shop')} className="sidebar-nav-item sidebar-nav-item-shop">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
        </svg>
      </span>
      <span className="nav-text">Get A Set</span>
    </button>
  </div>

  <button onClick={() => handleNavClick('Tutorial')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20" fill="currentColor">
        <path d="M80 259.8L289.2 345.9C299 349.9 309.4 352 320 352C330.6 352 341 349.9 350.8 345.9L593.2 246.1C602.2 242.4 608 233.7 608 224C608 214.3 602.2 205.6 593.2 201.9L350.8 102.1C341 98.1 330.6 96 320 96C309.4 96 299 98.1 289.2 102.1L46.8 201.9C37.8 205.6 32 214.3 32 224L32 520C32 533.3 42.7 544 56 544C69.3 544 80 533.3 80 520L80 259.8zM128 331.5L128 448C128 501 214 544 320 544C426 544 512 501 512 448L512 331.4L369.1 390.3C353.5 396.7 336.9 400 320 400C303.1 400 286.5 396.7 270.9 390.3L128 331.4z"/>
      </svg>
    </span>
    <span className="nav-text">Tutorial</span>
  </button>

  <button onClick={() => handleNavClick('rules')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20" fill="currentColor">
        <path d="M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C87.5 32 35.1 48.6 9 72.2c-5.8 5.3-9 13-9 21.1V435.1c0 10.7 9.2 18.2 19.6 15.5C60.2 440.1 100.2 432 144 432c55.1 0 100.5 18.1 105.6 39.5zM567 72.2c-26-23.6-78.5-40.2-135-40.2c-58.4 0-103.4 20-126.2 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.6 19.3 22.4 15.5c5.1-1.8 50.5-17.5 105.6-17.5c43.8 0 83.8 8.1 124.4 18.4c10.4 2.7 19.6-4.8 19.6-15.5V93.3c0-8.1-3.2-15.8-9-21.1z"/>
      </svg>
    </span>
    <span className="nav-text">Rules</span>
  </button>

  <button onClick={() => handleNavClick('puzzles')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20" fill="currentColor">
        <path d="M288 64C323.3 64 352 85.5 352 112C352 122.4 347.6 132 340 139.9C333.4 146.8 328 155.2 328 164.8C328 179.8 340.2 192 355.2 192L400 192C426.5 192 448 213.5 448 240L448 284.8C448 299.8 460.2 312 475.2 312C484.7 312 493.2 306.6 500.1 300C508 292.5 517.6 288 528 288C554.5 288 576 316.7 576 352C576 387.3 554.5 416 528 416C517.6 416 507.9 411.6 500.1 404C493.2 397.4 484.8 392 475.2 392C460.2 392 448 404.2 448 419.2L448 528C448 554.5 426.5 576 400 576L343.2 576C330.4 576 320 565.6 320 552.8C320 543.6 325.8 535.5 333.2 530C344.8 521.3 352 509.3 352 496C352 469.5 323.3 448 288 448C252.7 448 224 469.5 224 496C224 509.3 231.2 521.3 242.8 530C250.2 535.5 256 543.5 256 552.8C256 565.6 245.6 576 232.8 576L112 576C85.5 576 64 554.5 64 528L64 407.2C64 394.4 74.4 384 87.2 384C96.4 384 104.5 389.8 110 397.2C118.7 408.8 130.7 416 144 416C170.5 416 192 387.3 192 352C192 316.7 170.5 288 144 288C130.7 288 118.7 295.2 110 306.8C104.5 314.2 96.5 320 87.2 320C74.4 320 64 309.6 64 296.8L64 240C64 213.5 85.5 192 112 192L220.8 192C235.8 192 248 179.8 248 164.8C248 155.3 242.6 146.8 236 139.9C228.5 132 224 122.4 224 112C224 85.5 252.7 64 288 64z"/>
      </svg>
    </span>
    <span className="nav-text">Puzzles</span>
  </button>

  {authState.isAuthenticated && !authState.isGuest && (
    <button onClick={() => handleNavClick('spectator')} className="sidebar-nav-item">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20" fill="currentColor">
          <path d="M288 32c-129.6 0-246.4 70.4-288 192c41.6 121.6 158.4 192 288 192s246.4-70.4 288-192C534.4 102.4 417.6 32 288 32zM288 416c-88.2 0-160-71.8-160-160S199.8 96 288 96s160 71.8 160 160S376.2 416 288 416zM288 160c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64S323.3 160 288 160z"/>
        </svg>
      </span>
      <span className="nav-text">YugoVision</span>
    </button>
  )}

  {authState.isAuthenticated && !authState.isGuest && (
    <button onClick={() => handleNavClick('players')} className="sidebar-nav-item">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="20" height="20" fill="currentColor">
          <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.2 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/>
        </svg>
      </span>
      <span className="nav-text">Players</span>
    </button>
  )}

  {authState.isAuthenticated && !authState.isGuest && (
    <button onClick={() => handleNavClick('stats')} className="sidebar-nav-item">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20" fill="currentColor">
          <path d="M208.3 64L432.3 64C458.8 64 480.4 85.8 479.4 112.2C479.2 117.5 479 122.8 478.7 128L528.3 128C554.4 128 577.4 149.6 575.4 177.8C567.9 281.5 514.9 338.5 457.4 368.3C441.6 376.5 425.5 382.6 410.2 387.1C390 415.7 369 430.8 352.3 438.9L352.3 512L416.3 512C434 512 448.3 526.3 448.3 544C448.3 561.7 434 576 416.3 576L224.3 576C206.6 576 192.3 561.7 192.3 544C192.3 526.3 206.6 512 224.3 512L288.3 512L288.3 438.9C272.3 431.2 252.4 416.9 233 390.6C214.6 385.8 194.6 378.5 175.1 367.5C121 337.2 72.2 280.1 65.2 177.6C63.3 149.5 86.2 127.9 112.3 127.9L161.9 127.9C161.6 122.7 161.4 117.5 161.2 112.1C160.2 85.6 181.8 63.9 208.3 63.9zM165.5 176L113.1 176C119.3 260.7 158.2 303.1 198.3 325.6C183.9 288.3 172 239.6 165.5 176zM444 320.8C484.5 297 521.1 254.7 527.3 176L475 176C468.8 236.9 457.6 284.2 444 320.8z"/>
        </svg>
      </span>
      <span className="nav-text">My Stats</span>
    </button>
  )}

  <button onClick={() => handleNavClick('leaderboard')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" fill="currentColor">
        <path d="M64 400V80c0-8.8-7.2-16-16-16S32 71.2 32 80V416c0 17.7 14.3 32 32 32H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM128 336c-3.1 0-6.1-1.8-7.4-4.8-1.9-4.1.2-8.9 4.3-10.8l112-80c2.7-1.9 6.3-1.7 8.7.5l68.3 62.1L434.3 172.7c3.4-3 8.5-2.7 11.5.7 3 3.4 2.7 8.5-.7 11.5L318.7 308.3c-2.7 2.4-6.6 2.5-9.4.2l-68.9-62.6L133.4 334.2c-1.7 1.2-3.5 1.8-5.4 1.8z"/>
      </svg>
    </span>
    <span className="nav-text">Leaderboard</span>
  </button>

  {GLOBAL_CHAT_UI_ENABLED && authState.isAuthenticated && !authState.isGuest && (
    <button onClick={() => handleNavClick('chat')} className="sidebar-nav-item">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" fill="currentColor">
          <path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"/>
        </svg>
      </span>
      <span className="nav-text">Chat</span>
    </button>
  )}

  {TOURNAMENTS_NAV_UI_ENABLED && (
    <button onClick={() => handleNavClick('tournaments')} className="sidebar-nav-item">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20" fill="currentColor">
          <path d="M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.5 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"/>
        </svg>
      </span>
      <span className="nav-text">Tournaments</span>
    </button>
  )}

  {onGreedyClick && (
    <button onClick={() => handleNavClick('greedy')} className="sidebar-nav-item" title="Wager game — Greedy">
      <span className="nav-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20" fill="currentColor">
          <path d="M64 512V128h64v384H64zm160 0V256h64v256h-64zm160 0V192h64v320h-64zM544 0v512h-64V0h64z" />
        </svg>
      </span>
      <span className="nav-text">Greedy</span>
    </button>
  )}

  <button onClick={() => handleNavClick('settings')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" fill="currentColor">
        <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/>
      </svg>
    </span>
    <span className="nav-text">Settings</span>
  </button>

  <button onClick={() => handleNavClick('videos')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    </span>
    <span className="nav-text">YouTube</span>
  </button>

  <button onClick={() => handleNavClick('discord')} className="sidebar-nav-item">
    <span className="nav-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="20" height="20" fill="currentColor">
        <path d="M524.5 69.9C479 46.9 428.9 32 377 32c-4.5 8.2-9.2 18.2-12.6 27C318.9 55.6 272.6 55.5 223.5 59c-3.5-8.8-8-18.8-12.5-27C159.2 32 109 46.9 63.5 69.9 7.1 164.1-2.5 255.8 1.6 347.5c53.5 39.3 105.4 63.3 156.2 79.2 12.8-17.7 24.2-36.5 33.9-56.2-18.9-7.2-36.9-16.4-53.7-27.6 4.5-3.3 9.1-6.7 13.5-10.1 101.7 47.7 212 47.7 313.2 0 4.4 3.4 9 6.8 13.5 10.1-16.9 11.2-34.9 20.4-53.9 27.7 9.8 19.7 21.3 38.5 34.1 56.1 50.9-15.9 102.8-39.9 156.4-79.2 4.5-93.2-7.5-184.8-62.3-277.6zM240.3 337.1c-30.6 0-55.6-27.9-55.6-62.3s24.7-62.3 55.6-62.3 56.2 27.9 55.6 62.3-25 62.3-55.6 62.3zm159.4 0c-30.6 0-55.6-27.9-55.6-62.3s24.7-62.3 55.6-62.3 56.2 27.9 55.6 62.3-25 62.3-55.6 62.3z"/>
      </svg>
    </span>
    <span className="nav-text">Discord</span>
  </button>

  <button onClick={() => handleNavClick('about')} className="sidebar-nav-item">
  <span className="nav-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
    </svg>
  </span>
  <span className="nav-text">Q&A</span>
</button>
</nav>


      {/* Auth Section */}
      <div className="sidebar-auth">
        {authState.isAuthenticated ? (
          <div className="user-section">
                          <div className="user-info">
                <span className="welcome-text">
                  Welcome, {authState.user?.username}!
                </span>
              </div>
            <button className="sidebar-btn logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        ) : (
          <div className="auth-buttons">
            <button className="sidebar-btn signup-btn" onClick={onSignUpClick}>
              Sign Up
            </button>
            <button className="sidebar-btn signin-btn" onClick={onSignInClick}>
              Sign In
            </button>
          </div>
        )}
      </div>

      <div className="sidebar-copyright">
        © 2026 Migoyugo. All rights reserved.
      </div>

      {/* Footer Items */}
      {/* <div className="sidebar-footer">
        <button className="sidebar-footer-item">
          <span className="footer-icon">🌐</span>
          <span className="footer-text">English</span>
        </button>
        <button className="sidebar-footer-item">
          <span className="footer-icon">❓</span>
          <span className="footer-text">Support</span>
        </button>
      </div> */}
      </div>
    </>
  );
};

export default Sidebar;
